import { Nature } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import DelaiPaiementPanel from '../panel/DelaiPaiementPanel';
import FctvaPanel from '../panel/FctvaPanel';
import InformationsChorusProPanel from '../panel/InformationsChorusProPanel';
import InventairePanel from '../panel/InventairePanel';
import ProjetPanel from '../panel/ProjetPanel';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';

class ProfilEcritureMarcheRetGarantMandatDistDepense extends BaseProfilEcritureDepense {
	constructor() {
		super();
		this.code = PROFIL_ECRITURE.DEPENSE.MARCHE_RET_GARANT_MANDAT_DIST;
		this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.DEPENSE.RETENUE_GARANTIE;
		this.typePiece = TYPE_PIECE.DEPENSE.MARCHE;
		this.imputation.nature = Nature.REEL;
		this.modeDeReglement = [
			MODE_REGLEMENT.DEPENSE.NUMERAIRE,
			MODE_REGLEMENT.DEPENSE.CHEQUE,
			MODE_REGLEMENT.DEPENSE.VIREMENT,
			MODE_REGLEMENT.DEPENSE.VIREMENT_GROS_MT,
			MODE_REGLEMENT.DEPENSE.OPERATION_BUD_RATT,
			MODE_REGLEMENT.DEPENSE.AVIS_DE_REGL,
		];
		this.panels = [
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new DelaiPaiementPanel(true),
			new FctvaPanel(),
			new InformationsChorusProPanel(),
			new InventairePanel(),
			new ProjetPanel(),
			// TODO : add "Marche public" mandatory panel
			// TODO : add "Nomenclature achat" optional panel
		];
	}
}

export default ProfilEcritureMarcheRetGarantMandatDistDepense;
